export const STATUS_META = {
  pending_approval: { label: "Awaiting approval", tone: "warning" },
  placed: { label: "Placed", tone: "info" },
  confirmed: { label: "Confirmed", tone: "brand" },
  picked_up: { label: "Picked up", tone: "warning" },
  in_cleaning: { label: "In cleaning", tone: "warning" },
  ready: { label: "Ready", tone: "success" },
  out_for_delivery: { label: "Out for delivery", tone: "brand" },
  completed: { label: "Completed", tone: "success" },
  cancelled: { label: "Cancelled", tone: "error" },
};

export const FLOW_PICKUP = ["placed", "confirmed", "picked_up", "in_cleaning", "ready", "out_for_delivery", "completed"];
export const FLOW_DROPOFF = ["placed", "confirmed", "in_cleaning", "ready", "completed"];
export const flowFor = (mode) => (mode === "pickup" ? FLOW_PICKUP : FLOW_DROPOFF);

const MODE_OVERRIDES = {
  ready: { dropoff: "Ready for pickup" },
  completed: { pickup: "Delivered", dropoff: "Collected" },
};

const TAILORING_CATEGORY = "Tailoring";

const TAILORING_OVERRIDES = {
  placed: "Order Placed",
  picked_up: "Item Received",
  in_cleaning: "Stitching in Progress",
  ready: "Ready — Quality Checked",
};

const MIXED_OVERRIDES = {
  picked_up: "Item Received",
  in_cleaning: "In Progress",
};

export const orderKind = (items, categoryOf) => {
  if (!items || !items.length) return "laundry";
  const cats = new Set(items.map((it) => categoryOf(it.service_id) ?? ""));
  const hasTailoring = cats.has(TAILORING_CATEGORY);
  if (!hasTailoring) return "laundry";
  return cats.size > 1 ? "mixed" : "tailoring";
};

export const statusLabel = (status, mode, kind = "laundry") => {
  if (kind === "tailoring" && TAILORING_OVERRIDES[status]) return TAILORING_OVERRIDES[status];
  if (kind === "mixed" && MIXED_OVERRIDES[status]) return MIXED_OVERRIDES[status];
  if (mode) {
    const override = MODE_OVERRIDES[status]?.[mode];
    if (override) return override;
  }
  return STATUS_META[status]?.label ?? status;
};

const TAILORING_COMMENTS = {
  placed: "We've received your tailoring request.",
  confirmed: "Confirmed — we'll collect your fabric/garment soon.",
  picked_up: "Your garment/fabric has been received at our tailoring unit.",
  in_cleaning: "Our tailors are stitching your order.",
  ready: "Stitching complete — quality checked and ready!",
  out_for_delivery: "Your tailored piece is on its way to you.",
  completed: "Delivered — hope you love the fit!",
};
const LAUNDRY_COMMENTS = {
  placed: "We've received your order.",
  confirmed: "Your order is confirmed.",
  picked_up: "Your garments have been picked up.",
  in_cleaning: "Your garments are being cleaned.",
  ready: "Cleaned and ready!",
  out_for_delivery: "Your order is on its way to you.",
  completed: "Delivered — thank you for choosing Goldys!",
};
const MIXED_COMMENTS = {
  placed: "We've received your order.",
  confirmed: "Your order is confirmed.",
  picked_up: "Your items have been received.",
  in_cleaning: "Your order is being worked on — cleaning and stitching in progress.",
  ready: "All done and ready!",
  out_for_delivery: "Your order is on its way to you.",
  completed: "Delivered — thank you for choosing Goldys!",
};

export const statusComment = (status, kind = "laundry") => {
  if (status === "cancelled") return "This order was cancelled.";
  if (status === "pending_approval") return "This early/late pickup time needs the shop's approval — we'll confirm shortly.";
  const table = kind === "tailoring" ? TAILORING_COMMENTS : kind === "mixed" ? MIXED_COMMENTS : LAUNDRY_COMMENTS;
  return table[status] ?? "";
};

export const activeStatuses = ["pending_approval", "placed", "confirmed", "picked_up", "in_cleaning", "ready", "out_for_delivery"];

// Tailwind tone -> classes for status badges
export const TONE_CLASS = {
  info: "bg-[hsl(211_100%_52%_/_0.12)] text-[hsl(211_100%_42%)]",
  brand: "bg-[hsl(var(--brand)/0.12)] text-[hsl(var(--brand))]",
  brandSecondary: "bg-[hsl(var(--brand-secondary)/0.12)] text-[hsl(var(--brand-secondary))]",
  warning: "bg-[hsl(36_100%_50%_/_0.14)] text-[hsl(32_100%_40%)]",
  success: "bg-[hsl(142_71%_45%_/_0.14)] text-[hsl(142_60%_32%)]",
  error: "bg-[hsl(4_100%_59%_/_0.12)] text-[hsl(4_80%_50%)]",
};
